export default {"src":"/_next/static/media/dta.dd05271d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};